import { mutateCopyAdData } from "@/Services/AdEditor/mutateCopyAdData";
import { Button, Group, Loader, Modal, NumberInput, Stack, Text, Title } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import { IconAd, IconAdCircleOff } from "@tabler/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const ImportAdById = ({ form }) => {

    const { t } = useTranslation();

    const [value, setValue] = useState('');
    const mutation = mutateCopyAdData({ related_ad: value, firstStep: true });
    const [opened, { open, close }] = useDisclosure(false);

    const confirmCopy = () => {
        close();
        modals.openConfirmModal({
            size: '32rem',
            children: (
                <Stack align="stretch" justify="center" >
                    <Title order={4} align="center">
                        <IconAd size={28} stroke={1.5} /> <br />
                        {t('importAd.title')}
                    </Title>
                    <Text size="sm" align="center">
                        {t('importAd.overwriteWarning')} <Text component="span" fw="bold">{t('importAd.confirmQuestion')}</Text>
                    </Text>
                </Stack>
            ),
            labels: { confirm: t('importAd.title'), cancel: t('common.cancel') },
            confirmProps: { color: 'smartico-blue' },
            onConfirm: () => {

                const modalId = modals.open({
                    size: '32rem',
                    children: (
                        <Stack align="stretch" justify="center" pb="xl">
                            <Title order={4} align="center">
                                <Loader /> <br />
                                {t('importAd.matching')}
                            </Title>
                            <Text size="sm" align="center">
                                {t('importAd.matchingHint')}
                            </Text>
                        </Stack>
                    ),
                });

                mutation.mutate({}, {
                    onSuccess: (e) => {
                        modals.closeAll();
                        notifications.show({
                            color: 'green',
                            title: t('importAd.success'),
                            message: e.response?.data?.message || "",
                            position: 'top-center',
                        });
                        setTimeout(() => {
                            form.stepActions.handleClickStep(7);
                        }, 3000);
                    },
                    onError: (e) => {
                        modals.open({
                            modalId,
                            children: (
                                <Stack align="stretch" justify="center" pb="md">
                                    <Title order={4} align="center">
                                        <IconAdCircleOff size={48} stroke={1.5} color="red" /> <br />
                                        {e.response?.data?.message || ""}
                                    </Title>
                                    <Group justify="center" mt="md">
                                        <Button onClick={() => modals.closeAll()} variant="default">{t('common.cancel')}</Button>
                                        <Button onClick={openModal} color="smartico-blue">{t('importAd.tryAnother')}</Button>
                                    </Group>
                                </Stack>
                            ),
                        });

                    }
                });

            },
        })
    };

    const openModal = () => {
        modals.closeAll();
        setValue('');
        open();
    }

    return (
        <>
            <Modal
                opened={opened}
                onClose={close}
                title={t('importAd.title')}
                transitionProps={{ transition: 'fade', duration: 200 }}
            >
                <Stack>
                    <Text size="sm">
                        {t('importAd.modalHint')}
                    </Text>
                    <NumberInput label={t('importAd.oldAdId')} placeholder={t('importAd.oldAdIdPlaceholder')} value={value} onChange={setValue} hideControls />
                    <Group justify="space-between" mt="md">
                        <Button onClick={() => close} variant="default">{t('common.cancel')}</Button>
                        <Button onClick={confirmCopy} color="smartico-blue" disabled={value?.length < 1}>{t('importAd.title')}</Button>
                    </Group>
                </Stack>
            </Modal>
            <Button radius="md" color="smartico-blue" onClick={openModal}>
                {t('importAd.copyFromOldAd')}
            </Button>
        </>

    )
}